module.exports = __webpack_public_path__ + "img/acqua-blackhole.d11d78f8.jpeg";